import React, { Fragment } from 'react';
import { Slideshow, Intro, slideTextTypes, slideTypes } from 'dea-core';
import img3 from '../../assets/images/U1-T1-01C_L.svg';
import audio3 from '../../assets/vo/Opioid-M-One-01B.mp3';

const slides = [
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 6.7,
    image: img3,
    text: {
      type: slideTextTypes.BottomText,
      text: 'The Opioid Epidemic'
    },
    vo: {
      sources: [
        {
          src: audio3
        }
      ],
      transcript:
        'In this first module, we will be investigating what opioids are and how the epidemic evolved.'
    }
  }
];

export default {
  title: 'The Opioid Epidemic',
  path: '/engage/the-opioid-epidemic-2',
  content: (
    <Fragment>
      <Intro
        direction="Select the play button below to begin."
        title="The Opioid Epidemic"
      />
      <Slideshow slides={slides} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/engage/OpioidEpidemic2.js